var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mode_edit copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "On-boarding-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1015.000000, -414.000000)",
    fill: "#E6E6E6",
    id: "mode_edit-copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1015.000000, 414.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.8754243 L0,15 L3.12457575,15 L12.3399911,5.7845846 L9.2154154,2.66000885 L0,11.8754243 Z M14.7563297,3.36824602 C14.912332,3.21256333 15,3.00122041 15,2.78082578 C15,2.56043115 14.912332,2.34908823 14.7563297,2.19340554 L12.8065945,0.243670275 C12.6509118,0.087668049 12.4395689,3.700241e-16 12.2191742,0 C11.9987796,-3.700241e-16 11.7874367,0.087668049 11.631754,0.243670275 L10.106961,1.76846324 L13.2315368,4.89303899 L14.7563297,3.36824602 L14.7563297,3.36824602 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.59ed95d49711310fa5bc4e4bd76c02e1.svg";
export { ForwardRef as ReactComponent };